<template>
	<div class="center w-80">
		<div class="w-80 tc center pa4 f5 fw2">
			<div class="f4 fw3 mb2">Danielle Hayman</div>
			<div class="mt2">+ 1 (818) 943 - 0080</div>
			<div class="mt1">danielle@haymanllc.com</div>
			<div class="mt1">12650 Riverside Dr. Suite 100</div>
			<div class="mt1">Studio City, CA 91607</div>
		</div>
		<!-- <div class="pa3 f3 fw3">Let's Connect!</div> -->
		<ContactForm></ContactForm>

    <!-- Typeform option -->
		<!-- <div class="typeform-widget" data-url="https://reahmiyara.typeform.com/to/VA0uER" 
		style="width: 100%; height: 500px">  -->
	</div> 
</template>

<script>
import ContactForm from '@/components/ContactForm'
export default {	
	name: 'Contact',
	data() {
		return {
			
		}
	},
    methods: { 
    },
    components: {
    	ContactForm,
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue